
import "./TestStyles.css";
import { handleOnPopState } from '../utils/pop_state_utils.js';
import {useState, useRef, useEffect, useCallback} from "react";

import { uploadImageV2 } from "../utils/image_utils.js"; 
import { useNavigate, useLocation } from "react-router-dom";
import { playInstructionsOnce, handleAudioEndedCommon } from '../utils/audio_utils.js';
import { calculate_progress } from "../utils/progress_bar.js";
 

const QuestionSixteenBScreen = ({ userData }) => {
  const whiteScreenRef = useRef(null);
  const canvasRef = useRef();
  const [canvasHeight, setCanvasHeight] = useState();
  const [canvasWidth, setCanvasWidth] = useState();
  const [audio] = useState(new Audio("/audio/q16_instructions.mp3"));
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [nextButtonStyle, setNextButtonStyle] = useState("NextButton");
  const [audioPlayed, setAudioPlayed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const results = JSON.parse(localStorage.getItem("results"));
  const [nextPage] = useState("/Q16CScreen");        // Where this screen will navigate to next
  const [thisPage] = useState("screen_16_b");  
  const [filenameSuffix] = useState("Q16B");

  useEffect(() => {   // Page layout
    setCanvasWidth(whiteScreenRef.current.offsetWidth * 0.995);
    setCanvasHeight(whiteScreenRef.current.offsetHeight/2 * 0.95);
  }, []);

    const handleAudioEnded = useCallback(() => {
    handleAudioEndedCommon({
      audio,
      onEnded: handleAudioEnded,
      setAudioPlayed,
      setButtonDisabled,
      setNextButtonStyle
    });
  }, [audio]);

  useEffect(() => {   // Instructions effect
    if (!audioPlayed) {
      playInstructionsOnce({ audio, audioPlayed, setAudioPlayed, onEnded: handleAudioEnded });
    }
  }, [audio, audioPlayed, handleAudioEnded]); 

   
  // Implementing the popstate handler
  window.onpopstate = () => {
    handleOnPopState({ results, userData, navigate, location });
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.fillRect(0, 0, whiteScreenRef.current.offsetWidth, whiteScreenRef.current.offsetHeight);
    let isDrawing = false;

    const startPosition = (e) => {
      isDrawing = true;
      draw(e);
    };

    const endPosition = () => {
      isDrawing = false;
      ctx.beginPath();
    };

    const draw = (e) => {
      e.preventDefault();
      if (!isDrawing) return;
    
      let x, y;
      const rect = canvas.getBoundingClientRect();

      if (e.type === "touchmove" || e.type === "touchstart") {
        const touch = e.touches[0];
        x = touch.clientX - rect.left;
        y = touch.clientY - rect.top;
      } else {
        x = e.clientX - rect.left;
        y = e.clientY - rect.top;
      }
      ctx.lineWidth = 2;
    
      ctx.lineTo(x, y);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(x, y);
    };

    canvas.addEventListener("mousedown", startPosition);
    canvas.addEventListener("mouseup", endPosition);
    canvas.addEventListener("mousemove", draw);

    canvas.addEventListener("touchstart", startPosition);
    canvas.addEventListener("touchend", endPosition);
    canvas.addEventListener("touchmove", draw);

    return () => {
      canvas.removeEventListener("mousedown", startPosition);
      canvas.removeEventListener("mouseup", endPosition);
      canvas.removeEventListener("mousemove", draw);

      canvas.removeEventListener("touchstart", startPosition);
      canvas.removeEventListener("touchend", endPosition);
      canvas.removeEventListener("touchmove", draw);
    };
  }, []);

  /**
   * The `handleUploadImage` function takes a canvas element, converts it to a data URL, fetches the
   * data URL as a blob, uploads the blob to an S3 bucket as a png file, and updates the local storage 
   * with the file name.
   */
  const handleUploadImage = () => {uploadImageV2({
          canvasRef,
          userData,
          filenameSuffix: filenameSuffix, 
          thisPage: thisPage
        });
      }

  return (
    <div className="Container">
      <div className="InstructionsContainer">
        <img className="CharacterIcon" src="/icons/other.png" alt="Character Icon" />
        <progress variant="custom" className="ProgressBar" value={calculate_progress('asymptotic', 2, 54)} max="1"></progress>
        <p className="Instructions">Copy the diagram below in the empty space.</p>
      </div>
      <div className="whiteScreen" ref={whiteScreenRef}>
        <img className="cubeImage" src="/icons/cube.png" alt="Cube" />
        <canvas
        id="drawingCanvas"
          ref={canvasRef}
          className="canvas"
          width={canvasWidth}
          height={canvasHeight}
        />
      </div>

      <div className="NextButtonContainer">
        <button disabled={buttonDisabled} onClick={async () => {
          handleUploadImage();
          navigate(nextPage)
          }} className={nextButtonStyle}>
          <img src="/icons/arrow.png" alt="Next Button" />
        </button>
      </div>
    </div>
  );
};

export default QuestionSixteenBScreen;
